




import Component from "vue-class-component";
import { Prop, Vue } from "vue-property-decorator";

@Component({ name: "PageLoginTwitter" })
export default class PageLoginTwitter extends Vue {
  @Prop({ required: true })
  public readonly queryString!: { oauth_token?: string; oauth_verifier?: string };

  public mounted() {
    let url = this.queryString;
    if (url["oauth_token"] && url["oauth_verifier"]) {
      (window.opener as typeof window).TWTRAuthHandler({
        requestToken: url["oauth_token"] || "",
        verifier: url["oauth_verifier"] || "",
      });
    } else (window.opener as any).TWTRAuthHandler(null);
    window.close();
  }
}
